// material-ui
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';
import { getUser } from 'src/utils/Common';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
import {
  Grid,
  Typography,
  Snackbar,
  TextField,
  Button,
  Alert
} from '@mui/material';


// project imports
import SubCard from 'src/components/cards/SubCard';
import ThemeCustomization from 'src/themesNew';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'src/utils/axios';
import { makeStyles } from '@material-ui/styles';
import AlertComponent from 'src/components/Alert';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { confirmAlert } from 'react-confirm-alert';


// ==============================|| PROFILE 1 - CHANGE PASSWORD ||============================== //

const Transfer = ({ EmployeeNr, OrganizationTypeId, EmployeeType }) => {
  const theme = useTheme();
  const [Organization, setOrganization] = useState('');
  if (EmployeeNr === 0) {
    return <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <Alert variant="outlined" severity="error" sx={{ borderColor: theme.palette.warning.dark }}>
          <Typography variant='h5' style={{ color: 'red' }}>Önce Kayıt İşlemini Tamamlamanız Gerekli!....
          </Typography>
        </Alert>      </Grid>
    </Grid>
  };
  const [Warning, setWarning] = useState(false);
  const [WarningType, setWarningType] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState("");
  const [OrganizationControl, setOrganizationControl] = useState("");
  const [loading, setLoading] = useState(false);


  const [bolgeAdiKodu, setBolgeAdiKodu] = React.useState([]);
  const [BirimData, setBirimData] = React.useState([]);
  const [selectedbolgeAdiKodu, setSelectedbolgeAdiKodu] = React.useState([]);
  const [SelectedBirim, setSelectedBirim] = React.useState([]);
  const [DealerGroup, setDealerGroup] = React.useState([]);
  const [selectedDealerGroup, setselectedDealerGroup] = React.useState([]);

  const [DealerCompany, setDealerCompany] = React.useState([]);
  const [selectedDealerCompany, setSelectedDealerCompany] = React.useState([]);

  const [DealerArea, setDealerArea] = React.useState([]);
  const [selectedDealerArea, setSelectedDealerArea] = React.useState([]);
  const SessionUser = getUser();
  const [Dealer, setDealer] = React.useState([]);
  const [selectedDealer, setSelectedDealer] = React.useState([]);

  const [yetki, setYetki] = useState([]);
  const [active, setActive] = useState(0);

  const useStyles = makeStyles(() => ({
    ul: {
      '& .MuiPaginationItem-root': {
        '&.Mui-selected': {
          background: '#FF9800',
          color: 'white',
          borderRadius: '50%',
        },
      },
    },
  }));
  const classes = useStyles();
  const GetDealerData = () => {
    axios.get(`GetDealerDataTransfer/${0}/${0}/${0}`).then((response) => {
      setDealer(response.data);
    });
  }

  const GetDealerAreaData = (Company) => {
    axios.get(`GetDealerAreaData/${selectedDealerGroup?.Id}/${Company}`).then((response) => {
      setDealerArea(response.data);
    });
  }

  const GetDealerCompanyData = (Group) => {
    axios.get(`GetDealerCompanyData/${Group}`).then((response) => {
      setDealerCompany(response.data);
    });

  }

  const GetDealerGroupData = () => {
    axios.get(`GetDealerGroupData`).then((response) => {
      setDealerGroup(response.data);
    });

  }

  const getBolgeAdiKoduData = () => {
    axios.get(`GetBolgeAdiKodu/${SessionUser.TopServiceShopCode}`).then((response) => {
      var Data = response.data;
      var newData = Data.filter((item) => item.BirimKodu !== "0");

      setBolgeAdiKodu(newData);
    });

  }

  const getBirimData = (BirimKodu) => {
    if (BirimKodu === undefined) {
      setBirimData([]);
    } else {
      axios.get(`GetBirimData/${BirimKodu}`).then((response) => {
        setBirimData(response.data);
      });
    }
  }

  const getEmployeeYetki = () => {
    setLoading(true);
    axios.get(`GetEmployeeYetki`)
      .then((response) => {
        if (response.data && response.data.length > 0) {
          setYetki(response.data);
        } else {
          setYetki([]);
        }
        setLoading(false);
      });

  }


  useEffect(() => {
    setLoading(true);
    setOrganizationControl(OrganizationTypeId);
    axios.get(`GetWorkerInfo/${EmployeeNr}`).then((response) => {
      setOrganization(response.data[0]?.ServiceShopCode + '-' + response.data[0]?.ServiceShop + ' Organizasyonunda Çalışıyorsunuz!...');
      setActive(response.data[0]?.Active);
      setLoading(false);
    });
    getEmployeeYetki();
    setLoading(false);
    getBolgeAdiKoduData();
    GetDealerData();
    setLoading(false);
  }, []);

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };

  const handleTransfer = () => {
    if (active === 1) {
      setresponseMessage('Lütfen transfer işlemlerinizden önce çalışanı pasif durumuna alınız!...');
      setWarning(true);
      setWarningType("warning")
      return;
    }
    if (!SelectedBirim.BirimKodu || !selectedbolgeAdiKodu.BirimKodu) {
      setresponseMessage('Lütfen transfer işlemleriniz için birim kodu seçiniz!...');
      setWarning(true);
      setWarningType("warning")
      return;
    }
    confirmAlert({
      message: `${EmployeeNr} nolu elemanı, çalışan tipi ${EmployeeType} şeklinde transfer ediyorsunuz. Değiştirmek isterseniz çalışan tipi alanından doğru seçimi yapınız!`,
      buttons: [
        {
          label: 'Devam Et',
          onClick: () => handleTransferYes()
        },
        {
          label: 'İptal',
          onClick: () => { return; }
        }
      ]
    });

  }

  const handleTransferYes = () => {
    setLoading(true);

    if (OrganizationControl == 1) {
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      const requestData = {
        EmployeeId: EmployeeNr,
        ServiceShopCode: SelectedBirim.BirimKodu,
        RegisteredUser: "", //Oktadan alınıyor
        RoleId: SessionUser?.ManagementRoleId
      };

      axios.post('/SetApolloEmployeeTransfer', requestData, config)
        .then(response => {
          var data = response.data;
          setresponseMessage(data.ErrorDescription);
          setWarning(true);
          setWarningType(data.ErrorCode === "1000" ? "error" : "success")
        });
    } else {


    }
    setLoading(false);
  }

  return (
    <div>
      {
        loading ?
          <Backdrop className={classes.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <ThemeCustomization>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Snackbar
            open={Warning}
            autoHideDuration={10000}
            onClose={WarningClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <AlertComponent onClose={WarningClose} variant={WarningType} message={responseMessage}></AlertComponent>
          </Snackbar>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <SubCard
                title={
                  <div>
                    Tranfer İşlemleri:
                    <b style={{ color: 'red' }}>{Organization}</b>
                    <br /><br />
                    <b style={{ color: 'red' }}>Sadece pasif durumunda olan çalışanların tranfer işlemlerini gerçekleştirebilirsiniz!... </b>
                  </div>
                }
                style={{ minHeight: 500, maxHeight: 500 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} lg={6} style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}>
                    <Autocomplete
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={selectedbolgeAdiKodu}
                      options={bolgeAdiKodu}
                      getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                      disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferBolge')?.DISABLE_ALAN}
                      onChange={(event, newValue) => {
                        setSelectedbolgeAdiKodu(newValue);
                        getBirimData(newValue?.BirimKodu);
                        setSelectedBirim([])

                      }}
                      renderInput={(params) => <TextField {...params} label="Bölge" variant="outlined" />}

                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6} style={{ display: OrganizationControl == 1 ? 'block' : 'none' }}>
                    <Autocomplete
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={SelectedBirim}
                      options={BirimData}
                      getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                      disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferBirim')?.DISABLE_ALAN}
                      onChange={(event, newValue) => {
                        setSelectedBirim(newValue);


                      }}
                      renderInput={(params) => <TextField {...params} label="Servis" variant="outlined" />}

                    />
                  </Grid>


                  <Grid item xs={12} sm={12} lg={12} style={{ display: OrganizationControl == 2 ? 'block' : 'none' }}>
                    <Autocomplete
                      size="small"
                      id="combo-box-demo"
                      fullWidth
                      value={selectedDealer}
                      options={Dealer}
                      getOptionLabel={(option) => { return option.Id ? (option.Id + ' - ' + option.Dsc) : '-' }}
                      disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferDealer')?.DISABLE_ALAN}
                      onChange={(event, newValue) => {
                        setSelectedDealer(newValue);


                      }}
                      renderInput={(params) => <TextField {...params} label="Bayi" variant="outlined" />}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <Grid container spacing={1} justifyContent="flex-end">
                      <Grid item xs={12} style={{ textAlign: "right" }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          startIcon={<TransferWithinAStationIcon />}
                          disabled={yetki.find(item => item.ALAN_ADI === 'dsTransferButton')?.DISABLE_ALAN}
                          style={{ textTransform: 'none' }}
                          onClick={handleTransfer}
                        >
                          Tranfer
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </SubCard>
            </Grid>
          </Grid>
        </LocalizationProvider>
      </ThemeCustomization >
    </div>
  );
};

export default Transfer;
